/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Dashboards
05.Pages
06.Applications
  06.01.Chat
  06.02.Survey
  06.03.Todo
07.UI
  07.01.Alerts
  07.02.Badges
  07.03.Buttons
  07.04.Cards
  07.05.Carousel
  07.06.Charts
  07.07.Collapse
  07.08.Dropdowns
  07.09.Editors
  07.10.Forms
  07.11.Form Components
  07.12.Icons
  07.13.Input Groups
  07.14.Jumbotron
  07.15.Modal
  07.16.Navigation
  07.17.Popover & Tooltip
  07.18.Sortable
  07.19.Maps
  07.20.Tables
*/

const miMessages = {
  /* 01.General */
  'general.copyright': 'Myma.ai © 2019 All Rights Reserved.',

  /* 02.User Login, Logout, Register */
  'user.login-title': 'Login',
  'user.register': 'Register',
  'user.forgot-password': 'Forgot Password',
  'user.email': 'E-mail',
  'user.newpassword': 'New Password',
  'user.currentpassword': 'Current Password',
  'user.newpasswordagain': 'New Password Again',
  'user.password': 'Password',
  'user.forgot-password-question': 'Forget password?',
  'user.fullname': 'Full Name',
  'user.firstname': 'First Name',
  'user.lastname': 'Last Name',
  'user.login-button': 'LOGIN',
  'user.register-button': 'REGISTER',
  'user.reset-password-button': 'RESET',
  'user.buy': 'BUY',
  'user.username': 'Username',

  /* 03.Menu */
  'menu.app': 'Home',

  'menu.default': 'Default',
  'menu.analytics': 'Analytics',
  'menu.ecommerce': 'Ecommerce',
  'menu.content': 'Content',
  'menu.pages': 'Pages',
  'menu.data-list': 'Data List',
  'menu.thumb-list': 'Thumb List',
  'menu.image-list': 'Image List',
  'menu.details': 'Details',
  'menu.search': 'Search',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.forgot-password': 'Forgot Password',
  'menu.error': 'Error',
  'menu.applications': 'Applications',
  'menu.todo': 'To-do List',
  'menu.survey': 'Survey',
  'menu.chat': 'Chat',
  'menu.ui': 'UI',
  'menu.edit': 'Edit',
  'menu.alerts': 'Alerts',
  'menu.badges': 'Badges',
  'menu.buttons': 'Buttons',
  'menu.cards': 'Cards',
  'menu.carousel': 'Carousel',
  'menu.charts': 'Charts',
  'menu.collapse': 'Collapse',
  'menu.dropdowns': 'Dropdowns',
  'menu.editors': 'Editors',
  'menu.form-layouts': 'Form Layouts',
  'menu.form-components': 'Form Components',
  'menu.form-validations': 'Form Validations',
  'menu.icons': 'Icons',
  'menu.input-groups': 'Input Groups',
  'menu.jumbotron': 'Jumbotron',
  'menu.modal': 'Modal',
  'menu.navigation': 'Navigation',
  'menu.popover-tooltip': 'Popover & Tooltip',
  'menu.sortable': 'Sortable',
  'menu.tables': 'Tables',
  'menu.menu': 'Menu',
  'menu.subhidden': 'Subhidden',
  'menu.hidden': 'Hidden',
  'menu.visible': 'Visible',
  'menu.maps': 'Maps',
  'menu.landingpage': 'Landing Page',
  'menu.multipage-home': 'Multipage Home',
  'menu.singlepage-home': 'Singlepage Home',
  'menu.about': 'About',
  'menu.auth-login': 'Auth Login',
  'menu.auth-register': 'Auth Register',
  'menu.blog': 'Blog',
  'menu.blog-detail': 'Blog Detail',
  'menu.careers': 'Careers',
  'menu.confirmation': 'Confirmation',
  'menu.contact': 'Contact',
  'menu.docs': 'Docs',
  'menu.features': 'Features',
  'menu.prices': 'Prices',
  'menu.videos': 'Videos',
  'menu.mailing': 'Mailing',
  'menu.invoice': 'Invoice',
  'menu.blank-page': 'Coming soon...',
  'menu.types': 'Menu Types',
  'menu.levels': 'Menu Levels',
  'menu.third-level-1': 'Third Level 1',
  'menu.third-level-2': 'Third Level 2',
  'menu.third-level-3': 'Third Level 3',

  /* 04.Dashboards */
  'dashboards.update': 'Whakahou',
  'dashboards.save': 'Tiaki',
  'dashboards.saveSchedule': 'Tiaki te rārangi',
  'dashboards.pending-orders': 'Pending Orders',
  'dashboards.completed-orders': 'Completed Orders',
  'dashboards.refund-requests': 'Refund Requests',
  'dashboards.new-comments': 'New Comments',
  'dashboards.sales': 'Sales',
  'dashboards.orders': 'Orders',
  'dashboards.refunds': 'Refunds',
  'dashboards.recent-orders': 'Recent Orders',
  'dashboards.product-categories': 'Product Categories',
  'dashboards.cakes': 'Cakes',
  'dashboards.tickets': 'Tīkiti',
  'dashboards.calendar': 'Calendar',
  'dashboards.best-sellers': 'Best Sellers',
  'dashboards.per-session': 'Per Session',
  'dashboards.profile-status': 'Profile Status',
  'dashboards.payment-status': 'Payment Status',
  'dashboards.work-progress': 'Work Progress',
  'dashboards.tasks-completed': 'Tasks Completed',
  'dashboards.payments-done': 'Payments Done',
  'dashboards.order-stock': 'Order - Stock',
  'dashboards.categories': 'Categories',
  'dashboards.quick-post': 'Quick Post',
  'dashboards.title': 'Title',
  'dashboards.content': 'Content',
  'dashboards.ticket-count': 'Tatau Tīkiti',
  'dashboards.commonticketsubmission': 'Tukunga Tīkiti Noa',
  'dashboards.category': 'Category',
  'dashboards.save-and-publish': 'Save and Publish',
  'dashboards.top-viewed-posts': 'Top Viewed Posts',
  'dashboards.posts': 'Posts',
  'dashboards.pending-for-publish': 'Pending for publish',
  'dashboards.users': 'Users',
  'dashboards.on-approval-process': 'On approval process',
  'dashboards.alerts': 'Alerts',
  'dashboards.waiting-for-notice': 'Waiting for notice',
  'dashboards.files': 'Files',
  'dashboards.pending-for-print': 'Pending for print',
  'dashboards.logs': 'Logs',
  'dashboards.gogo': 'GOGO',
  'dashboards.magic-is-in-the-details': 'MAGIC IS IN THE DETAILS',
  'dashboards.yes-it-is-indeed': 'Yes, it is indeed!',
  'dashboards.advanced-search': 'Advanced Search',
  'dashboards.toppings': 'Toppings',
  'dashboards.type': 'Type',
  'dashboards.keyword': 'Keyword',
  'dashboards.search': 'Search',
  'dashboards.top-rated-items': 'Top Rated Items',
  'dashboards.country': 'Whenua',
  'dashboards.webVisitors': 'Ngā Manuhiri Paetukutuku',
  'dashboards.avatarClicks': 'Pāwhiri Āhua',
  'dashboards.wordCloud': 'Kapua Kupu',
  'dashboards.topic': 'Ngā Kaupapa',
  'dashboards.name': 'Ingoa',
  'dashboards.button': 'Pātene',
  'dashboards.visits': 'Haerenga',
  'dashboards.checkAvailability': 'Tirohia te wātea, ngā utu rānei',
  'dashboards.details': 'Taipitopito',
  'dashboards.roomsAvailability': 'Ngā rūma me te wātea',
  'dashboards.startChat': 'Tīmata kōrerorero',
  'dashboards.restaurantsBars': 'Wharekai me ngā pae inu',
  'dashboards.groupBooking': 'Tono ā-rōpū',
  'dashboards.promotions': 'Whakatairanga',
  'dashboards.weedingevents': 'Tāwhanga & Ngā Tukanga',
  'dashboards.lostsomething': 'Kua ngaro tētahi mea',
  'dashboards.producttext': 'Kuputuhi Hua',
  'dashboards.bookingroomnew': 'Mīhini Ruuma Hou',
  'dashboards.email': 'Rīpoata īmera',
  'dashboards.phone': 'Waea',
  'dashboards.zipcode': 'Waehere pouaka',
  'dashboards.marketingconsent': 'Whakaō mō te hokohoko',
  'dashboards.additionalinfo': 'Ngā pārongo tāpiri',
  'dashboards.viewallcontacts': 'Tirohia ngā hononga katoa',
  'dashboards.current': 'O nāianei',
  'dashboards.last7days': 'Ngā rā 7 kua pahure',
  'dashboards.last30days': 'Ngā rā 30 kua pahure',
  'dashboards.thisweek': 'Tēnei wiki',
  'dashboards.thismonth': 'Tēnei marama',
  'dashboards.previousmonth': 'Marama kua hori',
  'dashboards.yeartodate': 'Tau ki tēnei rā',
  'dashboards.lastyear': 'Tau o mua',
  'dashboards.all': 'Katoa',
  'dashboards.standardOccupancy': 'Noho Paerewa',
  'dashboards.max-occupancy': 'Te rahinga o te hunga e whakaaetia ana',
  'dashboards.numberOfThisType': 'Te maha o tēnei momo',
  'dashboards.displayOrder': 'Raupapa Whakaatu',
  'dashboards.provider': 'Kaiwhakarato',
  'dashboards.edit': 'Whakatika',
  'dashboards.delete': 'Mukua',
  'dashboards.addImages': 'Tāpiri Atahanga',
  'dashboards.location_ip': 'Ke rāhi tata i whakaritea mā te IP',
  'dashboards.near': 'Nēhi',
  'dashboards.referral': 'I toro mai te kaiwhakamahi mā tēnei paetukutuku',
  'dashboards.calling_party': 'Kaiwhakamahi karanga',
  'dashboards.called_party': 'Kaiwhakamahi karangahia',
  'dashboards.lastdial': 'Karanga whakamutunga',
  'dashboards.imagelink': 'Hononga Whakaahua',
  'dashboards.browsegallery': 'Tirotiro Gallery',
  'dashboards.changelog': 'Rārangi Panoni',
  'dashboards.externalresources': 'Rauemi o waho',
  'dashboards.webpage': 'Pae Tukutuku',
  'dashboards.web-pages': 'Ngā Whārangi Tukutuku',
  'dashboards.published': 'Kua Tuku',
  'dashboards.adddocument': 'Tāpiri Tuhinga',
  'dashboards.ready-to-publish': 'Tukua mō te whakaputa',
  'dashboards.draft': 'Hua tuhi',
  'dashboards.order-by': 'Raupapa mā',
  'dashboards.add-faq': 'Tāpiri FAQ',
  'dashboards.collections': 'Ngā kohinga',
  'dashboards.items': 'Ngā taonga',
  'dashboards.rooms-availability': 'Ngā rūma me te wātea',
  'dashboards.events-wedding-venues': 'Ngā huihuinga me ngā wāhi mārena',
  'dashboards.long-stay-enquiry': 'Pātai mō te noho roa',
  'dashboards.reservation-confirmation-request': 'Tono whakapūmau rāhui',
  'dashboards.modify-cancel-booking': 'Whakatikaina, whakakorea rānei te rāhui',
  'dashboards.left-something-behind': 'Kua mahue tētahi mea',
  'dashboards.invoice-copy': 'Tārua nama / rīhiti',
  'dashboards.sync': 'Whakahou',
  'dashboards.syncNow': 'Whakahou ināianei',
  'dashboards.add-web-page': 'Tāpiri Whārangi Tukutuku',
  'dashboards.sprint-title':
    'Tēnā koe ki Sprint, tō mātou whakangāwari whakamua hei whakangungu i te Tauira AI i roto i te 10× iti ake o te wa.',
  'dashboards.sprint-description':
    'Ka mahi tahi a Sprint ki a koe—hei tuku i te auahatanga, whakakaha i te pai o te mahi, me te whakaitenga nui i te waa e hiahiatia ana ki te whakangungu i te Kaikawe Matihiko.',
  'dashboards.sprint-feature':
    'Kua hoahoatia te āhuatanga Sprint kia tūnga ngā mōhiotanga mai i ngā rauemi kē, ā, he mea whai hua tēnei mō te whakaurunga tuatahi me ngā whakahou raraunga ā-kai. Ka mahia ki runga i tētahi pūnaha ā-mahi, ka whakarerekē a Sprint i te Pokapū Mātauranga i runga i ō rauemi kē kua whirihorahia e koe, ā, ka whai pānga tika ki ngā whanonga me ngā whakautu e whakaputaina ana e te AI. Mō āwhina ki te tautuhi i te Sprint, tēnā whakapā atu ki tō mātou kapa tautoko.',
  'dashboards.change-password': 'Huri Kupuhipa',
  'dashboards.sign-out': 'Takiuru Pūnuku',
  'dashboards.privacy-policy': 'Ngā Kaupapatatanga Matatika',
  'dashboards.help-center': 'Pūtahi Āwhina',
  'dashboards.switch-account': 'Huri Pūkete',
  'dashboards.business-settings': 'Tautuhinga Pakihi',
  'dashboards.notifications-allowed': 'Ngā Pānui Whakaaetia',
  'dashboards.dark-theme': 'Tema Pōuri',
  'dashboards.online': 'Ipurangi',
  'dashboards.offline': 'Kāore ipurangi',
  'dashboards.invoice-&-payments': 'Pire & Utu',
  'dashboards.upgrade-plan': 'Whakahou Mahere',
  'dashboards.add-room': 'Tāpiri Rūma',
  'dashboards.room-type': 'Momo Rūma',
  'dashboards.room-name': 'Ingoa Rūma',
  'dashboards.how-many-guests': 'Katoa ngā manuhiri mo ia rūma',
  'dashboards.number-of-rooms-this-type': 'Te maha o ngā rūma',
  'dashboards.number-of-bedrooms': 'Te maha o ngā rūma moe',
  'dashboards.number-of-livingrooms': 'Te maha o ngā rūma noho',
  'dashboards.minimum-adults': 'Pakeke iti rawa',
  'dashboards.maximum-adults': 'Pakeke nui rawa',
  'dashboards.maximum-children': 'Tamariki nui rawa',
  'dashboards.maximum-infants': 'Peepi nui rawa',
  'dashboards.extra-beds-allowed': 'Tukua te moenga tāpiri',
  'dashboards.booking-engine-code': 'Waehere Pūkenga Pēke',
  'dashboards.room-size': 'Rahi Rūma',
  'dashboards.balcony-area': 'Ātea Paetata',
  'dashboards.unit': 'Wāhanga',
  'dashboard.whatsapp_message': 'Tāuruhia tō karere ki konei...',
  'dashboard.whatsapp_reply_window':
    'E 24 hāora tō wā ki te whakahoki karere ki tētahi kiritaki i WhatsApp Business mai i te wā i tuku karere whakamutunga ai te kiritaki. Mēnā ka whakahoki koe i roto i tēnei wā 24 hāora tiaki kiritaki, ka taea e koe te tuku momo karere katoa. Ka kati ana te wā 24 hāora, ka taea noa te tuku karere mā ngā tauira karere kua whakaaetia i mua, ā, ka tīmata anō te wā 24 hāora ina whakahoki mai te kiritaki.',
  'dashboards.square-meters': 'Mita tapawha',
  'dashboard.pick_quick_reply':
    'Kōwhiria he whakautu tere, patohia rānei tō karere',
  'dashboard.hang_in_there': 'Tatari mai i a mātou e ngana ana ki te hono atu!',
  'dashboard.outbound_msg': 'Wā hei tuku i te karere putanga',
  'dashboard.message_sent': 'Kua tukuna pai tō karere!',
  'dashboard.failed_msg': 'I rahua te tuku karere',
  'dashboard.new_chat_message': 'Karere kōrerorero hou',
  'dashboard.user_msg':
    'He karere nō te kaiwhakamahi i roto i ngā hāora 24 kua pahure. Ka taea e koe te whakahoki ki tētahi karere. Kei te hiahia tonu koe ki te tuku i tēnei karere tauira, ki te whakahoki rānei ki tētahi atu karere?',
  'dashboard.us_number':
    'Kāore e tukuna ana ngā karere WhatsApp Pakihi ki ngā tau o Amerika nā te mea i whakatārewatia e Meta ngā karere hokohoko katoa ki ngā tau o Amerika i te 1 o Paengawhāwhā 2025.',
  'dashboard.error_msg': 'Tēnā koa whakakī tika i ngā wāhi pupuri katoa.',

  'web-widget.title': 'Ngā Tahua Widget Tukutuku mō te Kōrerorero Paetukutuku',
  /*Home page*/
  'dashboards.quickstartwithai': 'Tīmata Tere ki AI',
  'dashboards.fastestpathtoautomation':
    'Kei runga koe i te ara tere rawa ki te whakahaere aunoa me ngā taputapu AI',
  'dashboards.insightsthatempower': 'Ngā mārama e whakamana ana',
  'dashboards.trainchatbot': 'Whakangungua chatbot',
  'dashboards.automatewithforms': 'Aunoa mā ngā puka',
  'dashboards.inroomdigitalcompendium': 'Kohikohi Mamati i roto i te rūma',
  'dashboards.support': 'Tautoko',
  'dashboards.helpcenter': 'Pokapū Āwhina',
  'dashboards.searchfaqintegrations':
    'Rapu mō ngā tuhinga FAQ auau, ngā hononga, me ētahi atu.',
  'dashboards.asklivechat': 'Pātai ki tō mātou rōpū i te Korero Ora',
  'dashboards.inroomqrcode':
    'Waehere QR i roto i te rūma kia kite mō ngā pārongo mō te whare me te waahi',
  'dashboards.customizewebwidget':
    'Whakaritehia me te tāpiri i tētahi Pae Tukutuku ki tō paetukutuku me tētahi Chatbot AI kua whakauruhia',
  'dashboards.createcustomforms':
    'Waihangahia ngā puka ritenga kia whiwhi pānui mēnā ka tuku manuhiri i te puka',
  'dashboards.trainchatbotproperty':
    'Whakangungua chatbot ki ngā pārongo mō tō whare pēnei i te wā takiuru, ngā ngohe etc.',
  'dashboards.chatbotinsights':
    'Tirohia me pēhea te urupare a tō Chatbot ki ngā manuhiri me tiki mōhiotanga mō ngā tatauranga pēnei i ngā manuhiri paetukutuku, ngā pātai auau, me ētahi atu.',
  'dashboards.addaichatbottoyourwebsite': 'Tāpiri Chatbot AI ki tō Paetukutuku',

  /* 05.Pages */
  'pages.title.dashboards.analytics': 'Analytics',
  'pages.title.ari': 'Availability and Rates',
  'pages.title.conversations': 'Conversations',
  'pages.title.bookings': 'Reservations and Bookings',
  'pages.title.tickets': 'Leads and Tickets',
  'pages.title.propinfo': 'Responses',
  'pages.title.discounts': 'Discounts and Promotions',
  'pages.title.finance': 'Finance',
  'pages.title.integration': 'Integration',
  'pages.title.admin': 'Admin',
  'pages.add-new': 'ADD NEW',
  'pages.add-new-modal-title': 'Add New Item',
  'pages.display-options': 'Display Options',
  'pages.orderby': 'Order By : ',
  'pages.product-name': 'Product Name',
  'pages.category': 'Category',
  'pages.description': 'Description',
  'pages.status': 'Status',
  'pages.cancel': 'Cancel',
  'pages.submit': 'Submit',
  'pages.delete': 'Delete',
  'pages.another-action': 'Another action',
  'pages.actions': 'ACTIONS',
  'pages.header': 'Header',
  'pages.details': 'DETAILS',
  'pages.orders': 'ORDERS',
  'pages.rating': 'Rating',
  'pages.price': 'Price',
  'pages.ingredients': 'Ingredients',
  'pages.is-vegan': 'Is Vegan',
  'pages.order-status': 'Order Status',
  'pages.bake-progress': 'Bake Progress',
  'pages.popularity': 'Popularity',
  'pages.comments': 'Comments',
  'pages.error-title': 'Ooops... looks like an error occurred!',
  'pages.error-code': 'Error code',
  'pages.go-back-home': 'GO BACK HOME',
  'pages.mailing-info':
    'Mailing templates use inline styling and table layout to be displayed well at various service providers. To provide better usability we include it as regular html with dangerouslySetInnerHTML.',
  'pages.invoice-info':
    'Invoice template has an inline styled version for usage outside of the project as well as React version.',
  'pages.react-version': 'React Version',
  'pages.inline-version': 'Inline Styled Html Version',

  /* 06.Applications */

  /* 06.01.Chat */
  'chat.messages': 'Messages',
  'chat.contacts': 'Contacts',
  'chat.saysomething': 'Say something..',

  /* 06.02.Survey */
  'survey.delete': 'Delete',
  'survey.edit': 'Edit',
  'survey.add-new': 'ADD NEW',
  'survey.add-new-title': 'Add New Survey',
  'survey.title': 'Title',
  'survey.category': 'Category',
  'survey.label': 'Label',
  'survey.status': 'Status',
  'survey.cancel': 'Cancel',
  'survey.submit': 'Submit',
  'survey.another-action': 'Another action',
  'survey.display-options': 'Display Options',
  'survey.orderby': 'Order By : ',
  'survey.all-surveys': 'All Surveys',
  'survey.completed-surveys': 'Completed Surveys',
  'survey.categories': 'Categories',
  'survey.active-surveys': 'Active Surveys',
  'survey.labels': 'Labels',

  /* 06.03.Todo */
  'todo.add-new': 'ADD NEW',
  'todo.add-new-title': 'Add New Todo',
  'todo.title': 'Title',
  'todo.detail': 'Detail',
  'todo.category': 'Category',
  'todo.label': 'Label',
  'todo.status': 'Status',
  'todo.cancel': 'Cancel',
  'todo.submit': 'Submit',
  'todo.action': 'Action',
  'todo.another-action': 'Another action',
  'todo.display-options': 'Display Options',
  'todo.orderby': 'Order By : ',
  'todo.all-tasks': 'All Tasks',
  'todo.pending-tasks': 'Pending Tasks',
  'todo.completed-tasks': 'Completed Tasks',
  'todo.categories': 'Categories',
  'todo.labels': 'Labels',

  /* 07.UI */

  /* 07.01.Alerts */
  'alert.rounded': 'Rounded Alert',
  'alert.react-notifications': 'React Notifications',
  'alert.outline': 'Outline',
  'alert.primary': 'Primary',
  'alert.secondary': 'Secondary',
  'alert.info': 'Info',
  'alert.success': 'Success',
  'alert.warning': 'Warning',
  'alert.error': 'Error',
  'alert.filled': 'Filled',
  'alert.primary-text': 'This is a primary alert—check it out!',
  'alert.secondary-text': 'This is a secondary alert—check it out!',
  'alert.success-text': 'This is a success alert—check it out!',
  'alert.danger-text': 'This is a danger alert—check it out!',
  'alert.warning-text': 'This is a warning alert—check it out!',
  'alert.info-text': 'This is a info alert—check it out!',
  'alert.light-text': 'This is a light alert—check it out!',
  'alert.dark-text': 'This is a dark alert—check it out!',
  'alert.default': 'Default Alert',
  'alert.dismissing': 'Dismissing Alert',
  'alert.dismissing-text':
    'Holy guacamole! You should check in on some of those fields below.',
  'alert.dismissing-without-animate-text':
    'I am an alert and I can be dismissed without animating!',

  /* 07.02.Badges */
  'badge.sizes': 'Sizes',
  'badge.colors': 'Colors',
  'badge.outline': 'Outline',
  'badge.links': 'Links',
  'badge.counter-badges': 'Counter Badges',
  'badge.bootstrap-default': 'Bootstrap Default',
  'badge.primary': 'Primary',
  'badge.secondary': 'Secondary',
  'badge.success': 'Success',
  'badge.danger': 'Danger',
  'badge.warning': 'Warning',
  'badge.info': 'Info',
  'badge.light': 'Light',
  'badge.dark': 'Dark',

  /* 07.03.Buttons */
  'button.default': 'Bootstrap Default',
  'button.colors': 'Colors',
  'button.rounded': 'Rounded',
  'button.outline': 'Outline',
  'button.states': 'States',
  'button.sizes': 'Sizes',
  'button.button-groups': 'Button Groups',
  'button.large-button': 'Large Button',
  'button.small-button': 'Small Button',
  'button.extra-small-button': 'Extra Small Button',
  'button.block-button': 'Block Button',
  'button.active': 'Active',
  'button.disabled': 'Disabled',
  'button.basic': 'Basic',
  'button.toolbar': 'Toolbar',
  'button.nesting': 'Nesting',
  'button.vertical-variation': 'Vertical Variation',
  'button.checkbox-radio-button': 'Checkbox and Radio Button',
  'button.checkbox': 'Checkbox',
  'button.radio': 'Radio',
  'button.radio-button': 'Radio Button',
  'button.primary': 'Primary',
  'button.secondary': 'Secondary',
  'button.success': 'Success',
  'button.danger': 'Danger',
  'button.warning': 'Warning',
  'button.info': 'Info',
  'button.light': 'Light',
  'button.dark': 'Dark',
  'button.states-text':
    'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
  'button.click-here': 'Click Here',
  'button.states-text-alternate':
    'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
  'button.primary-link': 'Primary Link',
  'button.link': 'Link',
  'button.primary-button': 'Primary Button',
  'button.button': 'Button',
  'button.left': 'Left',
  'button.middle': 'Middle',
  'button.right': 'Right',
  'button.dropdown': 'Dropdown',
  'button.dropdown-link': 'Dropdown Link',

  /* 07.04.Cards */
  'cards.icon-card': 'Icon Card',
  'cards.image-card': 'Image Card',
  'cards.image-overlay-card': 'Image Overlay Card',
  'cards.image-card-list': 'Image Card List',
  'cards.tab-card': 'Tab Card',
  'cards.user-card': 'User Card',

  /* 07.05.Carousel */
  'carousel.basic': 'Carousel Basic',
  'carousel.single': 'Carousel Single',
  'carousel.without-controls': 'Carousel Without Controls',

  /* 07.06.Charts */
  'charts.line': 'Line Chart',
  'charts.polar': 'Polar Chart',
  'charts.area': 'Area Chart',
  'charts.scatter': 'Scatter Chart',
  'charts.bar': 'Bar Chart',
  'charts.radar': 'Radar Chart',
  'charts.pie': 'Pie Chart',
  'charts.doughnut': 'Doughnut Chart',
  'charts.shadow': 'Shadow',
  'charts.no-shadow': 'No Shadow',

  /* 07.07.Collapse */
  'collapse.basic': 'Basic',
  'collapse.toggle': 'Toggle',
  'collapse.accordion': 'Accordion',
  'collapse.controlled': 'Controlled',
  'collapse.uncontrolled': 'Uncontrolled',

  /* 07.08.Dropdowns */
  'dropdowns.basic': 'Basic',
  'dropdowns.controlled': 'Controlled',
  'dropdowns.uncontrolled': 'Uncontrolled',
  'dropdowns.dropdown': 'Dropdown',
  'dropdowns.header': 'Header',
  'dropdowns.action': 'Action',
  'dropdowns.another-action': 'Another Action',
  'dropdowns.right': 'Right',
  'dropdowns.left': 'Left',
  'dropdowns.drop-directions': 'Drop Directions',
  'dropdowns.dropright': 'Dropright',
  'dropdowns.dropleft': 'Dropleft',
  'dropdowns.small-button': 'Small Button',
  'dropdowns.large-button': 'Large Button',
  'dropdowns.sizing': 'Sizing',
  'dropdowns.split-button': 'Split Button Dropdowns',
  'dropdowns.dropup': 'Dropup',

  /* 07.09.Editors */
  'editors.draftjs': 'Draft.js',
  'editors.quill-standart': 'Quill Standard',
  'editors.quill-bubble': 'Quill Bubble',

  /* 07.10.Forms */
  'forms.basic': 'Basic',
  'forms.email': 'E-mail',
  'forms.email-muted': "We'll never share your email with anyone else.",
  'forms.password': 'Password',
  'forms.submit': 'Submit',
  'forms.horizontal': 'Horizontal',
  'forms.radios': 'Radios',
  'forms.first-radio': 'First radio',
  'forms.second-radio': 'Second radio',
  'forms.third-radio-disabled': 'Third disabled radio',
  'forms.checkbox': 'Checkbox',
  'forms.signin': 'Sign in',
  'forms.top-labels-over-line': 'Top Labels Over Line',
  'forms.tags': 'Tags',
  'forms.date': 'Date',
  'forms.state': 'State',
  'forms.top-labels-in-input': 'Top Labels In Input',
  'forms.email-u': 'E-MAIL',
  'forms.password-u': 'PASSWORD',
  'forms.tags-u': 'TAGS',
  'forms.date-u': 'DATE',
  'forms.state-u': 'STATE',
  'forms.grid': 'Form Grid',
  'forms.address': 'Address',
  'forms.address2': 'Address 2',
  'forms.city': 'City',
  'forms.city-message': 'Please select a city!',
  'forms.state-message': 'Please select a state!',
  'forms.zip': 'Zip',
  'forms.signup': 'Signup',
  'forms.inline': 'Inline',
  'forms.validation-availity': 'Availity Reactstrap Validation',
  'forms.validation-formik': 'Formik Validation',
  'forms.default': 'Default',
  'forms.firstname': 'First name',
  'forms.firstname-message': 'Please enter your first name!',
  'forms.lastname': 'Last name',
  'forms.lastname-message': 'Please enter your last name!',

  /* 07.11.Form Components */
  'form-components.custom-inputs': 'Custom Inputs',
  'form-components.checkboxes': 'Checkboxes',
  'form-components.radios': 'Radios',
  'form-components.inline': 'Inline',
  'form-components.react-select': 'React Select',
  'form-components.state-single': 'State Single',
  'form-components.state-multiple': 'State Multiple',
  'form-components.react-autosuggest': 'React Autosuggest',
  'form-components.date-picker': 'Date Picker',
  'form-components.date': 'Date',
  'form-components.date-range': 'Date Range',
  'form-components.date-with-time': 'Date with Time',
  'form-components.embedded': 'Embedded',
  'form-components.dropzone': 'Dropzone',
  'form-components.drop-files-here': 'Drop Files Here',
  'form-components.tags': 'Tags',
  'form-components.switch': 'Switch',
  'form-components.primary': 'Primary',
  'form-components.secondary': 'Secondary',
  'form-components.primary-inverse': 'Primary Inverse',
  'form-components.secondary-inverse': 'Secondary Inverse',
  'form-components.slider': 'Slider',
  'form-components.double-slider': 'Double Slider',
  'form-components.single-slider': 'Single Slider',
  'form-components.rating': 'Rating',
  'form-components.interactive': 'Interactive',
  'form-components.readonly': 'Readonly',
  'form-components.type-a-cake': 'Type a Cake',
  'form-components.start': 'Start',
  'form-components.end': 'End',
  'form-components.tables': 'Tables',
  /* 07.12.Icons */
  'icons.simplelineicons': 'Simple Line Icons',
  'icons.iconsmind': 'Iconsmind Icons',

  /* 07.13.Input Groups */
  'input-groups.basic': 'Basic',
  'input-groups.sizing': 'Sizing',
  'input-groups.small': 'Small',
  'input-groups.default': 'Default',
  'input-groups.large': 'Large',
  'input-groups.checkboxes-and-radios': 'Checkboxes and radios',
  'input-groups.multiple-inputs': 'Multiple Inputs',
  'input-groups.first-and-last-name': 'First and last name',
  'input-groups.multiple-addons': 'Multiple Addons',
  'input-groups.button-addons': 'Button Addons',
  'input-groups.button': 'Button',
  'input-groups.buttons-with-dropdowns': 'Buttons with Dropdowns',
  'input-groups.dropdown': 'Dropdown',
  'input-groups.header': 'Header',
  'input-groups.action': 'Action',
  'input-groups.another-action': 'Another Action',
  'input-groups.custom-select': 'Custom Select',
  'input-groups.options': 'Options',
  'input-groups.choose': 'Choose...',
  'input-groups.custom-file-input': 'Custom File Input',

  /* 07.14.Jumbotron */
  'jumbotron.hello-world': 'Hello, world!',
  'jumbotron.lead':
    'This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured content or information.',
  'jumbotron.lead-detail':
    'It uses utility classes for typography and spacing to space content out within the larger container.',
  'jumbotron.learn-more': 'Learn more',

  /* 07.15.Modal */
  'modal.basic': 'Basic',
  'modal.modal-title': 'Modal title',
  'modal.launch-demo-modal': 'Launch Demo Modal',
  'modal.scrolling-long-content': 'Scrolling Long Content',
  'modal.backdrop': 'Backdrop',
  'modal.backdrop-value': 'Backdrop value',
  'modal.right-modal': 'Right Modal',
  'modal.launch-right-modal': 'Launch Right Modal',
  'modal.nested-modal': 'Nested Modal',
  'modal.size': 'Size',
  'modal.launch-large-modal': 'Launch Large Modal',
  'modal.launch-small-modal': 'Launch Small Modal',

  /* 07.16.Navigation */
  'nav.basic': 'Nav Basic',
  'nav.active': 'Active',
  'nav.disabled': 'Disabled',
  'nav.disabled-link': 'Disabled Link',
  'nav.link': 'Link',
  'nav.longer-link': 'Longer nav link',
  'nav.another-link': 'Another Link',
  'nav.right': 'Right',
  'nav.dropdown': 'Dropdown',
  'nav.header': 'Header',
  'nav.action': 'Action',
  'nav.another-action': 'Another Action',
  'nav.horizontal-alignment': 'Nav Horizontal Alignment',
  'nav.vertical-alignment': 'Nav Vertical Alignment',
  'nav.pills': 'Nav Pills',
  'nav.fill-justify': 'Nav Fill and Justify',
  'nav.pills-dropdowns': 'Nav Pills with Dropdowns',
  'nav.pagination-basic': 'Pagination Basic',
  'nav.pagination-sizing': 'Pagination Sizing',
  'nav.large': 'Large',
  'nav.small': 'Small',
  'nav.center': 'Center',
  'nav.pagination-alignment': 'Pagination Alignment',
  'nav.breadcrumb-basic': 'Breadcrumb Basic',

  /* 07.17.Popover & Tooltip */
  'popover-tooltip.popover': 'Popover',
  'popover-tooltip.tooltip': 'Tooltip',

  /* 07.18.Sortable */
  'sortable.columns': 'Sorting Columns',
  'sortable.basic': 'Basic',
  'sortable.handles': 'Handles',

  /* 07.19.Maps */
  'maps.google': 'Google',
  'maps.yandex': 'Yandex',

  /* 07.20.Tables */
  'table.bootstrap-tables': 'Bootstrap Tables',
  'table.bootstrap-basic': 'Basic Table',
  'table.bootstrap-striped': 'Striped Rows',
  'table.bootstrap-bordered': 'Bordered Table',
  'table.bootstrap-borderless': 'Borderless Table',
  'table.bootstrap-hoverable': 'Hoverable Rows',
  'table.bootstrap-responsive': 'Responsive Table',
  'table.react-tables': 'React Tables',
  'table.react-pagination': 'Pagination',
  'table.react-scrollable': 'Scrollable',
  'table.react-advanced': 'Filter, Length and Jump',

  /* Property Info */
  'property-info.allcustomers': 'Ngā kiritaki katoa',
  'property-info.external-sources': 'Puna Kē',
  'property-info.faq': 'Ngā Pātai Auau',
  'property-info.documents': 'Tuhinga',
  'property-info.publish-ai': 'Tukuna mā te Atamai Horihori',
  'property-info.pre-built-templates': 'Ngā Tātauira Kua Hangaia Kē',
  'property-info.room-types': 'Ngā Momo Rūma',

  'property-info.about-property': 'About Property',
  'property-info.about-properties': 'About Properties',
  'property-info.facilities-services': 'Facilities & Services',
  'property-info.property-facilities': 'Property Facilities',
  'property-info.room-amenities': 'Room Amenities',
  'property-info.property-contact': 'Property Contact',
  'property-info.property-activities': 'Property Activities',
  'property-info.property-location': 'Property Location',
  'property-info.about-rooms': 'Rooms',
  'property-info.about-sites': 'About Sites',
  'property-info.special-emergencies': 'Emergencies',
  'property-info.gallery': 'Gallery',
  'property-info.policies': 'Policies',
  'property-info.nearby': 'Nearby',
  'property-info.transport': 'Transport',
  'property-info.location': 'Location',
  'property-info.about-rhproperty': 'About Retirement Home',
  'property-info.related-topics': 'Related Topics',
  'property-info.assistant-options': 'Assistant Options',
  'property-info.restaurant-assistant-information': 'Restaurant Information',
  'property-info.restaurant-assistant-options': 'Welcome Message',
  'property-info.channel-messages': 'Channel Messages',
  'property-info.icon.gallery': 'Icon Gallery',
  'property-info.copilot': 'Copilot',
  'property-info.sprint': 'Sprint',
  'property-info.home-information': 'Home Information',
  'property-info.loction': 'Locations',
  'property-info.rooms-and-images': 'Rooms & Images',
  'property-info.trainig-data': 'Training Data',
  'property-info.flows': 'Flows',
  'property-info.add-your-own': 'Add Your Own',
  'property-info-utility-miscellaneous': 'Miscellaneous',
  'property-info-utility-payment': 'Payments',
  'property-info-utility-broadband': 'Broadband',
  'property-info-utility-emergency': 'Emergency',
  'property-info-utility-mobile': 'Mobile',
  'property-info-utility-moving': 'Moving',
  'property-info.publishMonitor': 'Tuku me te Aroturuki',
  'property-info.webWidget': 'Widget Pae Tukutuku',
  'property-info.media': 'Pāpāho',
  /** Rate & Promo */
  'rate-promo.rate-plans': 'Rate Plans',
  'rate-promo.rate-plan-addons': "Add-on's",
  'rate-promo.rate-plan-promos': 'Promos',

  'title.property-information': 'Property Information',

  'property.message': 'Message',
  'property.example': 'Example',
  'property.link': 'Links',
  'property.image-carousel': 'Image Carousel',
  'property.Title': 'Title',
  'property.SubTitle': 'Sub Title',

  'property.add-invoke-api': 'Invoke Api',
  'property.add-message-button': 'Add Messages',
  'property.add-img-button': 'Add Images',
  'property.add-link-button': 'Add Link',
  'property.add-herocard-button': 'Add Hero Card',
  'property.add-api-button': 'Add Buttons',

  'menu.settings': 'Settings',
  'menu.workflows': 'Workflows',
  'menu.product_services': 'Products & Services',
  'menu.product_recommander': 'Product Recommender',
  'menu.digital_guide_book': 'Digital Guide Book',
  'menu.welcome_message': 'Welcome Message',
  'menu.about-property': 'About Property',
  'menu.property-facilities': 'Property Facilities',
  'menu.room-amenities': 'Room Amenities',
  'menu.property-contact': 'Propery Contact',
  'menu.about-rooms': 'Rooms',
  'menu.special-emergencies': 'Emergencies',
  'menu.show-filter': 'Filters',
  'menu.new': 'New',
  'menu.channel': 'Channels',
  'menu.application': 'Applications',
  'dashboards.welcomeMessage': 'Karere Nau Mai',
  'dashboards.personalizeGreeting':
    'Whakaritea te ara e mihi ai koe ki ngā kiritaki kia whakaata i tō waitohu, āhua, me ngā tikanga, kia tino pōwhiri ai rātou. Hangaia he mihi pōwhiri e hāngai ana ki tō waitohu.',
  'dashboards.addRoomDetails':
    'Tāpiritia ngā taipitopito mō ia ruma kia ngawari ai ki ngā manuhiri te kite i ngā mea katoa e hiahia ana rātou kia tīpato te whiriwhiri pai rawa atu, ā, kia māmā, kia tere ake te tukanga hōtaka.',
  'dashboards.trainAIFAQs': 'Whakangungua te AI ki ngā FAQ',
  'dashboards.manualQuestions':
    'Kāore e taea te whakautu i ētahi pātai mā ngā tuhinga anake, kāore rānei e kitea i runga i te paetukutuku. I konei, ka taea e koe te tāpiri pātai ā-ringa kia tino noho ngā mōhiohio e hiahiatia ana e ngā kiritaki e wātea ana i ō rātou ringaringa.',
  'dashboards.publishAI': 'Pānuitia te AI kia whakaata i ngā whakahoutanga hou',
  'dashboards.retrainAfterChanges':
    'Ka mahia e koe ngā whakarerekētanga ki te Knowledge Hub, ki ngā puka rānei, me whakarite kia whakangungua anō te chatbot ki ngā mōhiohio kua whakahouhia. Ko te pānuitanga o tō AI he mea kia tukuna e te chatbot ngā whakautu tino tika, tino hou hoki.',
  'dashboards.enhanceKnowledge':
    'Whakamanahia te mātauranga AI mā te whai i ngā pātai kāore i whakautua',
  'dashboards.reviewUnanswered':
    'Inā kāore te AI e taea te whakautu i tētahi pātai, kō ranei e whakarato noa ana i ngā kōrero iti, ka kitea aua pātai i konei. Arotakehia kia kite koe i ngā wāhi ngoikore i tō Knowledge Hub, me ngā pātai ahurei nō ngā manuhiri.',
  'dashboards.manageMedia': 'Whakahaerehia ngā pāpāho',
  'dashboards.mediaGallery':
    'Inā ka tukuake koe ngā whakaahua pērā i ngā rūma, taputapu, tohu, ngā āhua ā-ipurangi rānei, ka puta ki tēnei whare whakaahua, hei wāhi pokapū mō te whakahaere i ngā āhuatanga o te tirohanga me te whakarite kia kite ngā manuhiri i ngā mea motuhake o tō pakihi.',
  'dashboards.createForms':
    'Hangaia ngā puka ngāwari me te whiwhi whakamōhiotanga i ia tuku.',
  'dashboards.manageForms':
    'Hangaia me te whakahaere i ngā puka hei kohi mōhiohio kiritaki, whakarite whakamōhiotanga, me te whakarite kia rite ki ngā reo rerekē.',
  'dashboards.personalizeResponse':
    'Whakaritehia te āhua o te whakautu me te ahunga o te kōrero',
  'dashboards.controlConversation':
    'Ka whakaae tēnei āheinga matatau ki a koe ki te āhua me te whakahaere i te ahunga o ngā kōrero me ngā kiritaki puta noa i ngā ara rerekē.',

  'menu.guest-messaging': 'Karere Manuhiri',
  'guest-messaging.settings': 'Settings',
  'guest-messaging.outreach-setup': 'Outreach Setup',
  'guest-messaging.reservations': 'Reservations',
  'guest-messaging.insights_logs': 'Ngā tirohanga me ngā rārangi taki',
  'guest-messaging.placeholder': 'The Guest Messaging module is coming soon.',
  'guest-messaging.settings.placeholder': 'Set guest messaging preferences.',
  'guest-messaging.outreach.placeholder':
    'Set outreach campaigns and templates.',
  'guest-messaging.reservations.placeholder': 'Manage reservation messages.',
  'guest-messaging.reservation-source': 'Reservation Data Source',
  'guest-messaging.communication-channels': 'Communication Channels',
  'guest-messaging.templates': 'Templates',
  'guest-messaging.link': 'Link',
  'guest-messaging.business-profile': 'Business Profile',

  'dashboards.send': 'Tuku',
  'dashboards.hello': 'Kia ora',
  'dashboards.notificationsAllowed': 'Ngā pānui kua whakaaetia',
  'dashboards.allowNotifications': 'Whakaae i ngā pānui',
  'dashboards.views': 'Tirohanga',
  'dashboards.bookingURL': 'URL tono',
  'dashboards.searchTags': 'Ngā tapanga rapu',
  'dashboards.searchCategoryTags': 'Ngā tapanga kāwai rapu',
  'dashboards.bedroom': 'Moenga',
  'dashboards.addBedroom': 'Tāpiri ruma moe',
  'dashboards.frequency': 'Auau',
  'dashboards.includeSubpages': 'Tāpirihia ngā whārangi iti',
  'dashboards.enableFaqs': 'Whakakōwhiria ngā FAQ',
  'dashboards.faqsDescription':
    'Mā te whakakōwhiri i ngā FAQ ka taea e koe te whakauru pātai i te wā e tango ana te pūnaha i ngā whakautu mai i te ihirangi o te whārangi Tukutuku kia waihanga i ngā FAQ katoa',
  'dashboards.faq': 'FAQ',
  'dashboards.deleteDocument': 'Muku Tuhinga',
  'dashboards.confirmDelete': 'Kei te tino pākaha koe ki te muku?',
  'dashboards.addItem': 'Tāpiri Enei',
  'dashboards.addFirstWebPage': 'Tāpiri tō Whārangi Tukutuku Tuatahi',

  'dashboards.popular-compendium': 'Ngā Tūemi Rārangi Kai Rongo Nui',
  'dashboards.wordcloudofcompendium':
    'Kapua Kupu mō ngā Tūemi Rārangi Kai Rongo',
  'dashboards.wordcloudonthings':
    'Kapua Kupu mō ngā Pātai a ngā Manuhiri Paetukutuku me ngā Tūemi Rārangi Kai',
  'dashboards.common-asked': 'Commonly Asked Questions',
  'dashboards.website-visitor-asking':
    'Things Website Visitors Are Asking About',
  'dashboards.visit-country': 'Website Visit by Country',
  'dashboards.visit-traffic': 'Country Of The Website Traffic',
  'dashboards.rooms-product': 'Rooms & Products',
  'dashboards.popular-room-product': 'Popular rooms and products',

  'dashboards.messenger-stats': 'Popular Menu Items',
  'dashboards.messenger-stats-topic-view': 'Stats on Menu Item Views',
  'dashboards.messenger-stats-visits': 'Menu Item Views',
  'dashboards.opening-menu-items':
    'Number of Website Visitors opening Menu Items',
  'dashboards.tickets-by-category': 'Tīkiti mā te Kāwai',
  'dashboards.download': 'Tikiake',
  'dashboards.number-totalavatarclick': 'Total Avatar Clicks',
  'dashboards.subscribe-to-reports': 'Ohauru ki ngā pūrongo',
  'dashboards.clicks': 'Clicks',
  'dashboards.leads': 'Leads',
  'dashboards.hours': 'Hours',
  'dashboards.minutes': 'Minutes',
  'dashboards.connect': 'Tūhono',
  'dashboards.ai-chatbot': 'AI Chatbot',
  'dashboards.compendium': 'Compendium',
  'dashboards.compendium-digital-usage': 'Digital Compendium Usage',
  'dashboards.compendium-unique-visits': 'QR code scans/clicks',
  'dashboards.compendium-opening-menu-items': 'Number of menu items viewed',
  'dashboards.compendium-total-digital-clicks': 'Total Menu Item Views',
  'dashboards.compendium-total-qr-code': 'Total QR code Scans/Clicks',
  'dashboards.compendium-avg-menu-items': 'Avg Menu Item Views Per Scan',
  'dashboards.top-clicked-urls': 'Ngā URL kua tino pāwhiritia',
  'dashboards.top-clicked-urls-description': 'Tātari pāwhiri URL',
  'dashboards.urls': 'URL',
  'dashboards.externalDeleteMessage':
    'I hangaia tēnei tuhinga mai i ngā pūtake o waho. Ki te kore koe e hiahia kia hanga anō, me muku hoki te hōtaka tukutahi e pā ana.',
  'dashboards.deleteAndGoToExternalSources':
    'Muku ka haere ki ngā pūtake o waho',

  'property.delete': 'Delete',
  'menu.userroles': 'Users & Roles',
  'menu.members': 'Members',
  'menu.guest-pass': 'Guests Pass',
  'menu.ratebookings': 'Rates & Bookings',
  'dashboards.engagement-time': 'Digital Assistant Engagement Time',
  'dashboards.conversations-minutes':
    'Total Minutes & Overnight (7pm to 7am) Conversations Minutes',
  'dashboards.visitor-questions': 'Visitor Questions',
  'dashboards.recent-queries': 'Recent Queries',
  'dashboards.visitor-saying':
    'What your visitors are saying to the Digital Assistant',
  'dashboards.contacts-prechatform-leavemessage':
    'Stored Contacts from Pre Chat Form & Leave Message',
  'menu.dashboards': 'Insights',
  'menu.ari': 'Availability & Rates',
  'menu.conversations': 'Conversations',
  'menu.conversations.active': 'Active',
  'menu.conversations.archives': 'Archives',
  'menu.conversations.missed-responses': 'Missed Responses',
  'menu.conversations.ticket': 'Tickets',
  'menu.conversations.reply-templates': 'Reply Templates',
  'menu.bookings': 'Reservations & Bookings',
  'menu.tickets': 'Leads & Tickets',
  'menu.propinfo': 'Knowledge Hub',
  'menu.rate-promos': 'Rates & Promotions',
  'menu.finance': 'Finance',
  'menu.integration': 'Connect',
  'menu.admin': 'Admin & Security',
  'menu.favourites': 'Favourites',
  'menu.recommender': 'Conversation Flow',
  'menu.assistant-setup': 'Assistant Setup',
  'menu.admin-insights': 'Admin Insights',
  'menu.super-admin': 'Super Admin',
  'menu.groups': 'Groups',
  'menu.properties': 'Properties',
  'menu.service-provider': 'Service Providers',
  'menu.spaces': 'Spaces',
  'menu.availability': 'Te wātea',
  'menu.help': 'Āwhina',
  'menu.myAccounts': 'Ōku pūkete',

  'dashboards.space-booking': 'Space Booking',
  'dashboards.gift-voucher': 'Gift Vouchers',
  'dashboards.chatbots': 'Chatbots',
  'dashboards.form': 'From',
  'dashboards.to': 'To',
  'dashboards.active-groups': 'Active Groups',
  'dashboards.active-properties': 'Active Properties',
  'dashboards.live-properties': 'Live Properties',
  'dashboards.properties-going': 'Properties going live by date range',
  'dashboards.start-date': 'Start Date',
  'dashboards.end-date': 'End Date',

  'dashboards.website-visits': 'Website Visits',
  'dashboards.unique-visitors': 'Unique Visitors',
  'dashboards.last-week': 'Last Week',
  'dashboards.this-week': 'This Week',
  'dashboards.this-month': 'This Month',
  'dashboards.previous-month': 'Previous Month',
  'dashboards.yeartodate': 'Year to Date',
  'dashboards.lastyear': 'Last Year',
  'dashboards.last-7-days': 'Last 7 Days',
  'dashboards.last-30-days': 'Last 30 Days',
  'dashboards.last-60-days': 'Last 60 Days',
  'dashboards.last-90-days': 'Last 90 Days',
  'dashboards.conversion-rates': 'Conversion Rates',
  'dashboards.digital-assistant-engagement': 'Digital Assistant Engagement',
  'dashboards.total-overnight-conversations':
    'Total & Overnight (7pm to 7am) Conversations',
  'dashboards.percentage-accuracy': 'Kapi Mātauranga',
  'dashboards.percentage-conversion': 'Website Traffic to Chat Conversion',
  'dashboards.percentage-avatarclick': 'Website Traffic to Avatar Clicks',
  'dashboards.percentage-negativefeedback':
    'Negative Feedback as a %age of Avatar Clicks',
  'dashboards.percentage-amenties': 'Amenity Queries',
  'dashboards.percentage-booking': 'Booking Enquiries',
  'dashboards.percentage-webchats': 'Website Chats',
  'dashboards.percentage-facebookchat': 'Facebook Chats',
  //'dashboards.number-webchattime': 'Total Web Chat Time',

  'dashboards.number-webchattime': 'Total Conversation Time',
  'dashboards.number-totalconversation': 'Total Conversations',
  'dashboards.number-websiteconversation': 'Website Conversations',
  'dashboards.number-facebookconversation': 'Facebook Conversations',
  'dashboards.number-estimatedtimesaving': 'Estimated Time Saving',
  'dashboards.number-googlemapsconversation': 'Google Maps Conversations',
  'dashboards.number-whatsappconversation': 'WhatsApp Conversations',
  'dashboards.number-instagramconversation': 'Instagram Conversations',
  'dashboards.number-agentconversation': 'Agent Conversations',
  'dashboards.number-amenityqueries': 'Amenity Queries',
  'dashboards.number-bookingenquiries': 'Booking Queries',
  'dashboards.number-groupbookingenquiries': 'Group Booking Enquiries',
  'dashboards.number-eventenquiries': 'Event Enquiries',
  'dashboards.number-longstayenquiries': 'Long Stay Enquiries',
  'dashboards.number-totaltickets': 'Tickets',
  'dashboards.number-returncustomer': 'Return Customer',
  'dashboards.number-redirects': 'Website Redirects',
  'dashboards.number-bookingengineleads': 'Booking Engine Leads',
  'dashboards.number-roomnightsreferred': 'Room Nights Referred',
  'dashboards.number-revenuereferred': 'Revenue Referred',
  'menu.bookingsmenu': 'Bookings',
  'menu.guests': 'Guest Information',
  'menu.whatsnew': "What's New",

  'forms.forms-title': 'Form',
  'menu.formbuilder': 'Form Builder',
  'dashboards.trainAI': 'Whakangungua te AI mā ngā tuhinga',
  'dashboards.uploadDocuments':
    'Tukuatu ngā tuhinga hei āwhina i tō AI ki te ako mō tō pakihi me te āwhina i ngā kiritaki pēnei i a koe. Ka taea e koe te tāpiri kōnae .doc, .pdf, me .txt.',
  'menu.virtualfrontdesk': 'Virtual Front Desk',
  'menu.guestservice': 'Guest Services',
  'virtual-front.common-questions': 'Common Questions',
  'virtual-front.add-on-upsells': "Add-on's & Upsells",
  'virtual-front.service-order': 'Service Order',
  //'virtual-front.guest-service-add-on-upsells': "Guest Services & Add-on's",
  'virtual-front.guest-service-add-on-upsells': 'Digital Compendium',
  'virtual-front.outbound': 'Outbound',
  'virtual-messenger': 'Web Widget Menus',

  'missed-response.missed-response-title': 'Missed Response Title',
  //
  'content.allconversation': 'Ngā kōrero katoa',
  'content.active': 'Mahi tonu',
  'content.tickets': 'Tiketí',
  'content.filter': 'Tātari',
  'content.createtickets': 'Waihangatia he tiketí',
  'content.conversation': 'Kōrero',
  'content.knowledgesearch': 'Rapunga mōhiotanga',
  'content.reply': 'Whakautu',
  'content.visitorinfo': 'Mōhiohio manuhiri',
  'content.callinfo': 'Mōhiohio waea',
  'content.allinsights': 'Ngā tirohanga katoa',
  'content.availabilityrates': 'Wātea me ngā utu',
  'content.callback': 'Karanga anō',
  'content.close': 'Katia',
  'content.sms': 'SMS',
  'content.timestamp': 'Wā tohu',
  'content.topics': 'Ngā kaupapa',
  'content.callingparty': 'Kai karanga',
  'content.accountdomain': 'Rōpū pūkete',
  'content.calledparty': 'Kai karangahia',
  'content.recording': 'Rekoata',
  'content.phonesystemoriginationcallid': 'ID waea tīmatanga pūnaha',
  'content.phonesystemterminationcallid': 'ID waea mutunga pūnaha',
  'content.uniqueconversationid': 'ID kōrero ahurei',
  'content.regenerateinsights': 'Whakahou tirohanga',
  'content.customersentiment': 'Ngā kare ā-roto o te kiritaki',
  'content.neutral': 'Korekore',
  'content.customerreportedbroadbandoutage':
    'I pūrongo te kiritaki i te raru ipurangi me te tuku i tōna ID kiritaki me te rā tīmatanga mō te awhina.',
  'content.conversationinsights': 'Tirohanga kōrero',
  'content.broadbandoutage': 'Raru ipurangi',
  'content.customeridverification': 'Whakatau ID kiritaki',
  'content.serviceactivationdate': 'Rā tīmatanga ratonga',
  'content.followups': 'Aroturuki',
  'content.actionneeded': 'Me mahi',
  'content.uniqueConversationId': 'ID Kōrero Ahurei',
  'content.uniqueChatId': 'ID Kōrero Motuhake',
  'content.recording&transcript': 'Tārua me te Whakarāpopoto',
  'content.chatinsights': 'Mātauranga Korero',
  'content.visitedpages': 'Ngā whārangi torohia',
  'content.deviceinfo': 'Ngā mōhiohio taputapu',
  'content.chatstartedonthispage':
    'I tīmata te korerorero i runga i tēnei whārangi',
  'content.prechatinfo': 'Mōhiohio i mua i te korerorero',
  'content.notes': 'Tuhipoka',
  'content.reassign': 'Tohu anō',
  'content.open': 'Tuwhera',
  'content.dismiss': 'Whakakore',
  'content.add_placeholder': 'Tāpiri uara wāhi pupuri',
  'content.mobile_number': 'Tau waea pūkoro',
  'content.please_select': 'Tīpakohia koa',
  'content.sendwhatsapp': 'Tukuna karere WhatsApp',

  /* Missed Response */
  'feedback.missed-question': 'Pātai kāore i whakautua',
  'feedback.conversation-summary': 'Whakarāpopototanga o te kōrerorero',
  'feedback.dates-in-spanish': 'Me tuhi ngā rā ki te reo Paniora',
  'feedback.resolve': 'Whakatika',
  'feedback.ignore': 'Waiho',

  //integration
  // mi-MI
  'integration.select_properties': 'Kōwhiria ngā rawa',
  'integration.select_properties_enabled':
    'Kōwhiria ngā rawa kua whakahohea mā tēnei whakaurunga',
  'integration.services_addons': 'Kōwhiria ngā ratonga me ngā taupānga tāpiri',
  'integration.services_visible':
    'Kōwhiria ngā ratonga me ngā taupānga tāpiri e kitea ana i tēnei whārangi',
  'integration.appearance': 'Titiro',
  'integration.appearance_customize':
    'Tīpakohia te ingoa o tō kaiawhina matihiko, te ātaahua, me te whakarite i ō tae',
  'integration.booking_calendar': 'Maramataka Tohutohu',
  'integration.booking_calendar_style':
    'Kōwhiria te āhua kāremoema mō te pou whakamārama maramataka',
  'integration.nudges': 'Whakatatūpato',
  'integration.nudges_setup':
    'Tautuhia ngā karere whakahaerenga ki te whakawhanaunga i ngā manuhiri paetukutuku',
  'integration.position': 'Tūranga',
  'integration.position_control':
    'Arahina te tūranga o te taputapu korerorero i runga i tō paetukutuku',
  'integration.custom_fonts': 'Momotuhi Ritenga',
  'integration.custom_fonts_upload':
    'Tukuake momotuhi ritenga hei whakamahi mō te whārangi',
  'integration.custom_css': 'CSS Ritenga',
  'integration.custom_css_usage':
    'Whakamahia te CSS ki te whakarite i tō Papakupu Matihiko',
  'integration.location': 'Wāhi',
  'integration.location_embed': 'Tāpiri i tō hononga wāhi whakauruhia',
  'integration.external_links': 'Hononga Waho',
  'integration.external_links_add': 'Tāpiri āu hononga',
  'integration.language': 'Reo',
  'integration.widget_languages': 'Kōwhiria ngā reo mō te taparahi korerorero',
  'integration.chatbot_contact': 'Humahu',
  'integration.chatbot_enable': 'Whakahohe tō kaiawhina matihiko',
  'integration.chatbot_security': 'Puritia tō karere haumaru',
  'integration.chatbot_trusted_pages':
    'Rārangihia ngā whārangi ka whakawhirinaki kia whakaaturia te Humahu',
  'integration.chatbot_publish': 'Pānuitia tō kaiawhina matihiko',
  'integration.chatbot_install':
    'Tāruatia te wāhanga waehere hei tāuta i tō kaiawhina matihiko',
};
export default miMessages;
